import { Component, OnInit } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd} from '@angular/router';

declare function closeNavMobile() : any;
@Component({
  selector: 'app-layout',
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.css']
})
export class DashboardLayoutComponent implements OnInit {
  showSidebar = true; 

  constructor(private router: Router) { 
    this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationStart){
            closeNavMobile();
        }
        if (event instanceof NavigationEnd){
          if(event.url.includes('dashboard/hiration')) {
            this.showSidebar = false;
          } else {
            this.showSidebar = true;
          }
        }
    });
  }

  ngOnInit(): void {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd){
        if(event.url.includes('dashboard/hiration')) {
          this.showSidebar = false;
        } else {
          this.showSidebar = true;
        }
      }
    });
  }

}
